import React from "react";
import { Box, Button, useTheme } from "@mui/material";
import { MOBILE_TOUCH_MIN_PX } from "../../../theme/mobileLayout";

/**
 * Bottom action bar for filter panels.
 * Clear edits the open panel draft; Apply commits it and closes the panel.
 */
export default function FilterPanelActions({
  onClear,
  onApply,
  showClear = true,
  showApply = true,
  clearDisabled = false,
  applyDisabled = false,
  clearLabel = "Clear",
  applyLabel = "Apply",
  mobileTouchTargets = false,
}) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  if (!showClear && !showApply) return null;

  return (
    <Box
      data-testid="filter-panel-actions"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: showApply ? "space-between" : "flex-start",
        gap: 1,
        mt: 1.25,
        pt: 1.25,
        borderTop: `1px solid ${
          isDark ? "rgba(255,255,255,0.1)" : "rgba(88,89,91,0.12)"
        }`,
      }}
    >
      {showClear ? (
        <Button
          type="button"
          onClick={onClear}
          disabled={clearDisabled}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            fontSize: 13,
            minWidth: 0,
            minHeight: mobileTouchTargets ? MOBILE_TOUCH_MIN_PX : undefined,
            px: 0.75,
            color: clearDisabled
              ? theme.palette.text.disabled
              : theme.palette.text.secondary,
            "&:hover": {
              backgroundColor: "transparent",
              color: clearDisabled ? theme.palette.text.disabled : "#D80000",
            },
          }}
        >
          {clearLabel}
        </Button>
      ) : (
        <Box />
      )}

      {showApply ? (
        <Button
          type="button"
          variant="contained"
          disableElevation
          onClick={onApply}
          disabled={applyDisabled}
          sx={{
            textTransform: "none",
            fontWeight: 700,
            fontSize: 13,
            minHeight: mobileTouchTargets ? MOBILE_TOUCH_MIN_PX : 34,
            px: 2,
            borderRadius: "10px",
            backgroundColor: theme.palette.primary.main,
            "&:hover": { backgroundColor: theme.palette.primary.dark },
            "&.Mui-disabled": {
              backgroundColor: isDark ? "rgba(255,255,255,0.08)" : `${theme.palette.primary.main}40`,
              color: isDark ? "rgba(255,255,255,0.35)" : "rgba(255,255,255,0.8)",
            },
          }}
        >
          {applyLabel}
        </Button>
      ) : null}
    </Box>
  );
}
